import { $t, confirm, projectStore, userRole } from '@dabble/app';
import { writable } from '@dabble/data/stores/store';
import { Doc } from '@dabble/data/types';
import { mdiImage } from '@mdi/js';

export const titleImageDocId = writable('');

export const setTitleImage = [
  {
    key: 'novel_title_image',
    icon: mdiImage,
    action: openDropTitleImageModal,
    hide: (doc: Doc) => (doc.image ? true : false),
    disabled: () => !userRole.get(),
  },
];

export const removeTitleImage = [
  {
    key: 'novel_title_image_remove',
    icon: mdiImage,
    action: deleteTitleImage,
    hide: (doc: Doc) => (doc.image ? false : true),
    disabled: () => !userRole.get(),
  },
];

function openDropTitleImageModal(doc: Doc) {
  titleImageDocId.set(doc.id);
}

async function deleteTitleImage(doc: Doc) {
  const shouldDelete = await confirm($t('novel_image_delete'), $t('novel_image_delete_message'));

  if (shouldDelete) {
    projectStore.updateDoc(doc.id, { image: null });
  }
}
